import { useRouteError, Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

type Props = {
  status?: number;
};

export default function ErrorPage({ status }: Props) {
  const message =
    status === 404
      ? "요청한 페이지를 찾을 수 없습니다."
      : status === 403
        ? "접근 권한이 없습니다."
        : status === 500
          ? "서버 오류가 발생했습니다."
          : "알 수 없는 오류가 발생했습니다.";

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={900} mb={1}>
          {status} Error
        </Typography>
        <Typography color="text.secondary" mb={3}>
          {message}
        </Typography>

        <Button variant="contained" component={Link} to="/">
          대시보드로 이동
        </Button>
      </Paper>
    </Box>
  );
}
